import {Link} from 'react-router-dom';
import React, { useContext } from 'react';
import {WebContext} from '../webcontext';
import moment from 'moment';



export default function Listen() {
  const service = useContext(WebContext);
  console.log(service.web);

  

  switch(service.web?.service.template) {
    case 2:
      return (
        <main id="content-area" class="content-area" style={{opacity: 1}}>
          <div data-page-title="Listen &amp, Connect" x-data="{ alexaOpen: false }">
            <h1 class="page-title">Listen &amp, Connect</h1>
            <p class="text-secondary" style={{textAlign:'center', maxWidth:600, margin:'0 auto 3rem', fontSize:'1.1rem'}}>
              Listen to DNA Radio — choose your favourite platform and never miss a beat.
            </p>

            <div class="grid-3">

        
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'var(--accent-coral)'}}><i class="fas fa-headphones"></i></div>
                <h2 class="listen-title">Web Player</h2>
                <p class="text-secondary listen-desc">Listen live right now in your browser — no app or download needed. Just hit play in the bar above.</p>
                <a href="/" data-nav="" class="btn listen-btn">Listen Now</a>
              </div>

              {/*}
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'var(--accent-coral)'}}><i class="fab fa-google-play"></i></div>
                <h2 class="listen-title">Android App</h2>
                <p class="text-secondary listen-desc">Get the 4 The Music app on Google Play — listen on the go with a native Android experience.</p>
                <a href="https://play.google.com/store/apps/details?id=com.fourthemusic" target="_blank" rel="noreferrer" class="btn listen-btn">Get on Google Play</a>
              </div>

              
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'var(--text-cream)'}}><i class="fab fa-apple"></i></div>
                <h2 class="listen-title">iOS App</h2>
                <p class="text-secondary listen-desc">Get the 4 The Music app on the App Store — listen on the go on your iPhone or iPad.</p>
                <a href="https://apps.apple.com/us/app/4-the-music-radio/id6456125970" target="_blank" rel="noreferrer" class="btn listen-btn">Get on the App Store</a>
              </div>

              
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'var(--accent-coral)'}}><i class="fab fa-amazon"></i></div>
                <h2 class="listen-title">Amazon Alexa</h2>
                <p class="text-secondary listen-desc">Listen to 4 The Music on any Alexa-enabled device with a simple voice command.</p>
                <button class="btn btn-ghost listen-btn">
                  <i class="fas fa-chevron-down" class="alexaOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  Setup Instructions
                </button>
                <div x-show="alexaOpen" style={{background: 'var(--bg-primary)', borderRadius: 8, padding: '1rem', marginTop: '0.5rem', display: 'none'}}>
                  <ol style={{margin:0, paddingLeft:'1.4rem', display:'flex', flexDirection:'column', gap:'0.6rem', color:'var(--text-secondary)', fontSize:'0.95rem'}}>
                    <li>Open the <strong>Alexa app</strong> on your phone</li>
                    <li>Tap <strong>More</strong> → <strong>Skills &amp, Games</strong></li>
                    <li>Search for <strong>“4 The Music”</strong> and tap <strong>Enable</strong></li>
                    <li>Say: <span style={{color:'var(--accent-coral)', fontWeight:600}}>“Alexa, open four the music radio”</span></li>
                  </ol>
                </div>
              </div>

              
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'#4F01A3'}}><i class="fas fa-tv"></i></div>
                <h2 class="listen-title">Roku</h2>
                <p class="text-secondary listen-desc">Watch 4 The Music live on your Roku TV or streaming stick — full schedule, live DJs, and chat on the big screen.</p>
                <a href="https://channelstore.roku.com/details/e94b40970590a913536a5dff9bcc4fad:85b2f25690033349bb881f84c7d23f82/4-the-music" target="_blank" rel="noreferrer" class="btn listen-btn" style={{background:'#4F01A3', borderColor:'#4F01A3', color:'#fff', display:'inline-flex', alignItems:'center', gap:'0.5rem'}}>
                  Add to <img src="/images/roku-logo-white.svg" alt="Roku" style={{height:'0.9em', verticalAlign:'middle'}} />
                </a>
              </div>
              */}
              

              {service.web.platforms.map((e, i) => {
                console.log(e);
                switch(e.platform) {
                  case 'Twitch':
                    return (
                      <div key={i} class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                        <div class="listen-icon" style={{color:'var(--accent-purple)'}}><i class="fab fa-twitch"></i></div>
                        <h2 class="listen-title">Twitch</h2>
                        <p class="text-secondary listen-desc">Watch live DJ sets on Twitch with video. Follow us to get notified when we go live.</p>
                        <a href={e.website} target="_blank" rel="noreferrer" class="btn listen-btn">Follow on Twitch</a>
                      </div>
                    )
                  case 'Mixcloud':
                    return (
                      <div key={i} class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                        <div class="listen-icon" style={{color:'var(--accent-coral)'}}><i class="fab fa-mixcloud"></i></div>
                        <h2 class="listen-title">Mixcloud</h2>
                        <p class="text-secondary listen-desc">Browse and replay all our mixes on Mixcloud — follow us to get notified of new uploads.</p>
                        <a href={e.website} target="_blank" rel="noreferrer" rel="noreferrer" class="btn listen-btn">Open Mixcloud</a>
                      </div>
                    )
                  default:
                    return (<></>)
                }
              })}


              {/*}              
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'var(--accent-coral)'}}><i class="fas fa-play-circle"></i></div>
                <h2 class="listen-title">HearThis.at</h2>
                <p class="text-secondary listen-desc">Find our full mix archive on HearThis.at — another great way to listen on the go.</p>
                <a href="https://hearthis.at/4themusic" target="_blank" rel="noreferrer" class="btn listen-btn">Open HearThis</a>
              </div>

              
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'var(--accent-coral)'}}><i class="fab fa-youtube"></i></div>
                <h2 class="listen-title">YouTube</h2>
                <p class="text-secondary listen-desc">Subscribe to our YouTube channel for recorded mixes, live streams, and highlights.</p>
                <a href="https://www.youtube.com/@4TheMusicOfficial" target="_blank" rel="noreferrer" class="btn listen-btn">Subscribe</a>
              </div>

              
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'#1DB954'}}><i class="fab fa-spotify"></i></div>
                <h2 class="listen-title">Spotify</h2>
                <p class="text-secondary listen-desc">Follow our Spotify profile for curated playlists from our DJs — updated weekly with tracks from live mixes.</p>
                <a href="https://open.spotify.com/user/31dbxbhst6o2bghlpxwdwr3eb5ua" target="_blank" rel="noreferrer" class="btn listen-btn" style={{background:'#1DB954', borderColor:'#1DB954', color:'#fff'}}>Follow on Spotify</a>
              </div>
              */}
              

              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'var(--accent-coral)'}}><i class="fas fa-share-nodes"></i></div>
                <h2 class="listen-title">Social Media</h2>
                <p class="text-secondary listen-desc">Follow us for updates, show announcements, and behind-the-scenes content from our DJs.</p>
                <div style={{display:'flex', flexWrap:'wrap', gap:'0.6rem', marginTop:'auto'}}>
                  {Object.keys(service.web?.service).filter(elem => elem.indexOf('s_') === 0 && elem !== 's_website').map((e, i) => {
                    switch(e) {
                      case 's_facebook':
                        return (
                          <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="btn btn-ghost" style={{fontSize:'0.85rem', padding:'0.4rem 0.8rem'}}>
                            <i class="fab fa-facebook-f"></i> Facebook
                          </a>
                        )
                      case 's_mixcloud':
                        return (
                          <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="btn btn-ghost" style={{fontSize:'0.85rem', padding:'0.4rem 0.8rem'}}>
                            <i class="fab fa-mixcloud"></i> Mixcloud
                          </a>
                        );
                      case 's_twitch':
                        return (
                          <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="btn btn-ghost" style={{fontSize:'0.85rem', padding:'0.4rem 0.8rem'}}>
                            <i class="fab fa-twitch"></i> Twitch
                          </a>
                          );
                      default:
                        return (<>something</>);
                    }
                  })}
                </div>
              </div>

              {/*
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'#1C9C85'}}><i class="fas fa-broadcast-tower"></i></div>
                <h2 class="listen-title">TuneIn</h2>
                <p class="text-secondary listen-desc">Find 4 The Music in the TuneIn directory — listen live in your browser or via the TuneIn app on phone, smart speaker, or car.</p>
                <a href="https://tunein.com/radio/4-The-Music-106-s345333/" target="_blank" rel="noreferrer" rel="noopener" class="btn listen-btn" style={{background:'#1C9C85', borderColor:'#1C9C85', color:'#fff'}}>Open on TuneIn</a>
              </div>

              
              <div class="card listen-card" style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '2rem'}}>
                <div class="listen-icon" style={{color:'#E91A20'}}><i class="fas fa-broadcast-tower"></i></div>
                <h2 class="listen-title">MyTuner Radio</h2>
                <p class="text-secondary listen-desc">Stream 4 The Music through MyTuner Radio — available on the web, iOS, Android, and desktop.</p>
                <a href="https://mytuner-radio.com/radio/4-the-music-483564/" target="_blank" rel="noreferrer" rel="noopener" class="btn listen-btn" style={{background:'#E91A20', borderColor:'#E91A20', color:'#fff'}}>Open on MyTuner</a>
              </div>*/}

            </div>
          </div>
          {/*
          <style>
              .spotify-section {
                  margin: 4rem 0 2rem;
              }
              .spotify-section-head {
                  text-align: center;
                  margin-bottom: 2rem;
              }
              .spotify-section-head h2 {
                  margin: 0 0 0.5rem;
                  font-size: 1.8rem;
                  display: inline-flex;
                  align-items: center;
                  gap: 0.6rem;
              }
              .spotify-grid {
                  display: grid;
                  grid-template-columns: repeat(6, 1fr);
                  gap: 0.75rem;
              }
              @media (max-width: 900px) {
                  .spotify-grid { grid-template-columns: repeat(3, 1fr), }
              }
              @media (max-width: 480px) {
                  .spotify-grid { grid-template-columns: repeat(2, 1fr), }
              }
              .spotify-card {
                  position: relative;
                  display: block;
                  aspect-ratio: 1;
                  border-radius: 12px;
                  overflow: hidden;
                  text-decoration: none;
                  background: var(--bg-card-hover, #2a3444);
                  transition: transform 0.15s, box-shadow 0.15s;
              }
              .spotify-card:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 8px 20px rgba(29, 185, 84, 0.25);
              }
              .spotify-card img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  display: block;
              }
              .spotify-card-placeholder {
                  width: 100%, height: 100%;
                  display: flex, align-items: center, justify-content: center;
                  font-size: 3rem, color: #1DB954;
              }
              .spotify-card-overlay {
                  position: absolute;
                  left: 0, right: 0, bottom: 0;
                  padding: 0.5rem 0.55rem;
                  background: linear-gradient(to top, rgba(0,0,0,0.85) 40%, rgba(0,0,0,0));
                  color: #fff;
                  display: flex, flex-direction: column, gap: 0.1rem;
              }
              .spotify-card-name {
                  font-weight: 600;
                  font-size: 0.75rem;
                  line-height: 1.15;
              }
              .spotify-card-cta {
                  font-size: 0.65rem;
                  color: #1DB954;
                  display: inline-flex, align-items: center, gap: 0.25rem;
              }
              .listen-card {
                  display: flex;
                  flex-direction: column;
                  gap: 0.75rem;
                  padding: 2rem;
              }
              .listen-card-soon {
                  opacity: 0.7;
              }
              .soon-badge {
                  display: inline-block;
                  margin-left: 0.4rem;
                  padding: 0.15rem 0.5rem;
                  font-size: 0.65rem;
                  font-weight: 600;
                  text-transform: uppercase;
                  letter-spacing: 0.05em;
                  border-radius: 999px;
                  background: var(--accent-coral);
                  color: #fff;
                  vertical-align: middle;
              }
              .listen-icon {
                  font-size: 2.25rem;
                  line-height: 1;
              }
              .listen-title {
                  margin: 0;
                  font-size: 1.3rem;
              }
              .listen-desc {
                  flex: 1;
                  line-height: 1.6;
              }
              .listen-btn {
                  align-self: flex-start;
                  min-width: 140px;
                  text-align: center;
              }
              @media (max-width: 640px) {
                  .listen-card {
                      padding: 1.5rem;
                  }
                  .listen-icon {
                      font-size: 2rem;
                  }
                  .listen-btn {
                      align-self: stretch;
                      min-width: unset;
                  }
              }
          </style>
          */}

        </main>
      )
    case 1:
      return (
        <>
        </>
      )
    default:
      return (<></>)
  }

  
}
